module.exports = __webpack_public_path__ + "img/2026-02-27c_2.b893f2fc.jpg";